import React from 'react'

type CardType = {
	children?: React.ReactNode
	className?: string
	defaultBordered?: boolean
} & React.ComponentPropsWithoutRef<'div'>

export default function Card({ children, defaultBordered, className, ...props }: CardType) {
	return (
		<div
			className={`flex bg-headersActive p-4 rounded-2xl ${className} ${defaultBordered ? 'border border-c' : 'border  border-c '}`}
			{...props}>
			{children}
		</div>
	)
}
